module.exports = new __parcel__URL__("darkmending.10b81ff8.png").toString();